import clsx from 'clsx';
import React from 'react';
import styles from './styles.css.js';
import DarkRibbon from '../internal/components/dark-ribbon';

interface WizardFormHeaderProps {
  children: React.ReactNode;
  isMobile: boolean;
  isVisualRefresh: boolean;
}

export default function WizardFormHeader({ children, isMobile, isVisualRefresh }: WizardFormHeaderProps) {
  return (
    <div
      className={clsx(
        styles['form-header'],
        isMobile && styles['form-header-mobile'],
        isVisualRefresh && styles['form-header-refresh']
      )}
    >
      <DarkRibbon isRefresh={isVisualRefresh}>
        <div
          className={clsx(
            styles['form-header-content'],
            isVisualRefresh && styles['form-header-content-refresh'],
            isMobile && styles['form-header-content-mobile']
          )}
        >
          {children}
        </div>
      </DarkRibbon>
    </div>
  );
}
